import { render, staticRenderFns } from "./marketManagement.vue?vue&type=template&id=624fd4f7&scoped=true"
import script from "./marketManagement.vue?vue&type=script&lang=js"
export * from "./marketManagement.vue?vue&type=script&lang=js"
import style0 from "./marketManagement.vue?vue&type=style&index=0&id=624fd4f7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624fd4f7",
  null
  
)

export default component.exports